import Vue from 'vue'

const RECIPESTEP_SET_ENTITY =(state, payload)=> {
            
    state.data.entity_id = payload
};

const RECIPESTEP_SET_UNIT =(state, payload)=> {
   
    state.data.unit_id = payload
};

const RECIPESTEP_SET_UNITVALUE =(state, payload)=> {
            
    state.data.unitvalue = payload
};

const RECIPESTEP_SET_COOKINGLOSS =(state, payload)=> {
            
    state.data.cookingloss = payload
};

const RECIPESTEP_SET_PREPARELOSS =(state, payload)=> {
            
    state.data.prepareloss = payload
};


const RECIPESTEP_SET_PREPARATIONS =(state, payload)=> {
            
    state.data.preparation_ids = payload
};

const RECIPESTEP_SET_TREATMENTS =(state, payload)=> {
            
      
    state.data.treatment_ids = payload
};

const RECIPESTEP_SET_INGREDIENT =(state, payload)=> {
    
    state.data.ingredient_id = payload        
};

const RECIPESTEP_SET_DUPLICATE =(state, payload)=> {
            
    state.data.duplicate = payload
};

const RECIPESTEP_SET_RECIPESTEPS =(state, payload)=> {

        state.recipesteps=payload
};

const RECIPESTEP_SET_FORRECIPE =(state, payload)=> {
        
        state.forrecipe=state.recipesteps.filter(recipestep=>recipestep.entity_id==payload)
        //alert(JSON.stringify(state.forrecipe))
};

const RECIPESTEP_SET_RECIPESTEP =(state, payload)=> {

        state.data.entity_id=payload.entity_id,
        state.data.unit_id=payload.unit_id,
        state.data.treatment_ids=payload.treatments.map(t=>t.treatment_id),
        state.data.ingredient_id=payload.ingredient_id,
        state.data.ingredient=payload.ingredient,
        state.data.recipe = payload.recipe,
        state.data.unitvalue=payload.unitvalue,
        state.data.preparation_ids=payload.preparations.map(p=>p.preparation_id),
        state.data.notices = payload.notices
        state.data.cookingloss = payload.cookingloss
        state.data.prepareloss = payload.prepareloss
        state.data.duplicate=false    
    
};

const RECIPESTEP_INIT_RECIPESTEP =(state)=> {

        
        state.data.entity_id=null,
        state.data.unit_id=null,
        state.data.preparation_ids=null,
        state.data.treatment_ids=null,
        state.data.ingredient=null,
        state.data.ingredient_id=null,
        state.data.recipe=null,
        state.data.unitvalue='',
        state.data.notices='',
        state.data.cookingloss='0',
        state.data.prepareloss='0',
        state.data.duplicate=false,
        state.forrecipe=[]
};

export default {
    RECIPESTEP_SET_ENTITY,
    RECIPESTEP_SET_UNIT,
    RECIPESTEP_SET_UNITVALUE,
    RECIPESTEP_SET_PREPARATIONS,
    RECIPESTEP_SET_TREATMENTS,
    RECIPESTEP_SET_INGREDIENT,
    RECIPESTEP_SET_DUPLICATE,
    RECIPESTEP_SET_RECIPESTEPS,
    RECIPESTEP_SET_RECIPESTEP,
    RECIPESTEP_INIT_RECIPESTEP,
    RECIPESTEP_SET_FORRECIPE,
    RECIPESTEP_SET_COOKINGLOSS,
    RECIPESTEP_SET_PREPARELOSS
};